import React from "react";
import Progress from "../components/Progress";
import ErrorDialog from "../components/dialog/ErrorDialog";
import { connect, ConnectedProps } from "react-redux";
import { ApplicationState } from "../store";
import { ErrorState } from "../store/error";
import { resetServerError } from "../store/error";

const connector = connect(
  (state: ApplicationState) => ({
    error: state.error as ErrorState,
  }),
  {
    resetServerError,
  },
);

type ReduxProps = ConnectedProps<typeof connector>;
type Props = ReduxProps & {
  children?: React.ReactNode;
};

const PageEventsProvider: React.FC<Props> = (props: Props) => {
  const [errorDialogOpen, setErrorDialogOpen] = React.useState(false);
  const [errorHeader, setErrorHeader] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const [lastErrorTimestamp, setLastErrorTimestamp] = React.useState<number | undefined>(undefined);

  React.useEffect(() => {
    // Show dialog if error exists and timestamp is new or lastErrorTimestamp is undefined
    if (props.error && props.error.message && (lastErrorTimestamp === undefined || props.error.timestamp !== lastErrorTimestamp)) {
      setErrorHeader(props.error.header || "Server Error");
      setErrorMessage(props.error.message || "");
      setErrorDialogOpen(true);
      setLastErrorTimestamp(props.error.timestamp);
    }
  }, [props.error, lastErrorTimestamp]);

  const handleCloseErrorDialog = () => {
    setErrorDialogOpen(false);
    if (props.error && props.error.redirectUrl) {
      window.location.href = props.error.redirectUrl;
    }
    props.resetServerError();
  };

  return (
    <>
      {props.children}
      <Progress />
      <ErrorDialog open={errorDialogOpen} onClose={handleCloseErrorDialog} errorHeader={errorHeader} errorMessage={errorMessage} />
    </>
  );
};

export default connector(PageEventsProvider);
